/**
 * Constants for Menu Filters Component
 *
 * Timeframe constants moved to `global-filters/global-filters.constants.ts`
 * when the timeframe became a standalone nav-bar control.
 */

export const PRESET_NAMES = {
  CUSTOM: 'Custom',
};
